var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOrangeArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 7,
  height: 8,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.5 4.866a1 1 0 0 1 0-1.732L5 .536a1 1 0 0 1 1.5.866v5.196a1 1 0 0 1-1.5.866L.5 4.866Z",
  fill: "#F26B0B"
})));
export default SvgOrangeArrowLeft;